import { getPageDataObjectWithType, getVisitorObject } from './adobeAnalyticsUtil';

export const buildAnalyticsMetadata = (organizationResult, ip) => {
  const {
    userAssociation,
    userAnonymity,
    webUserId,
    account,
    accountId,
    organizations,
  } = organizationResult || { };
  const content = [];
  if (organizations) {
    organizations.map((org) => content.push({
      format: 'MIME-XHTML',
      type: 'sd:choice',
      id: `sd:choice:choice_id:${org.id}`,
      title: org.name,
    }));
  }
  return {
    page: Object.assign(getPageDataObjectWithType('chooseorg'), { type: 'cp-cr' }),
    visitor: getVisitorObject(ip, webUserId, accountId, account, userAnonymity, userAssociation),
    content,
  };
};

export const buildSubmitAnalyticsMetadata = (
  organizationResult, defaultChoice, selectedChoice,
) => ({
  adobeAnalyticsMetadata: {
    content: [{
      format: 'MIME-XHTML',
      type: 'sd:account',
      id: organizationResult.accountId
        ? `sd:account:account_id:${organizationResult.accountId}` : '',
      title: organizationResult.accountName,
      detail: defaultChoice === selectedChoice
        ? 'sd:account:selection:default'
        : 'sd:account:selection:manual',
    }],
    feature: { name: 'sd:ChooseOrg' },
  },
});

export const buildOrganizationList = (organizationResult) => {
  const defaultChoice = organizationResult && organizationResult[0] ? organizationResult[0].id : '';
  return {
    organizationList: organizationResult,
    defaultChoice,
    selectedChoice: defaultChoice,
  };
};
